module.exports = __webpack_public_path__ + "img/IEER_logo-White.1a0f7b8f.png";